import { ICON_SIZE_TO_BG_SIZE_RATIO } from '../constants';
export const bgSizeToIconSize = (size) => {
    if (typeof size === 'string') {
        const matches = size.match(/(?<value>[0-9.]+)(?<unit>.*)/);
        if (matches && matches.groups) {
            const { unit, value } = matches.groups;
            return `${Number(value) / ICON_SIZE_TO_BG_SIZE_RATIO}${unit}`;
        }
    }
    return undefined;
};
//# sourceMappingURL=bgSizeToIconSize.js.map